<template>
	<v-container class="mt-12 pt-8" style="background: #fafafa;">
		<v-row style="background: #fafafa;">
			<v-col cols="12" md="12" class="" PANNELS>
				<v-card :loading="loading">
					<v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`">
						{{ i18n["past_transactions"] }}
					</v-card-title>
					<Paging :resourceSettings="resourceSettings" :resource="resource" @loadResource="loadResource"
						@pageByNumber="pageByNumber" />
					<v-card-text>
						<v-row>
							<v-col cols="12" class="mb-2 py-0">
									<v-timeline dense clipped>
											<v-timeline-item v-for="(transaction, key) in resource.data" 
													:key="`call-${key}`" 
													:color="(transaction.done || transaction.approved) ? 'success' : 'red'" 
													icon-color="grey lighten-2" 
													small>
													<v-row justify="space-between" class="align-center elevation-2">
															<v-col cols="12" class="py-1">
																<div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px; font-weight:700;">
																		{{ i18n.employee_name }}
																</div>
																<v-chip dark color="info" label small :class="`${arabic ? 'arFont' : 'enFont'}`">
																	{{ transaction.employee_name.name }}
																</v-chip>
															</v-col>
															<v-col cols="6" class="py-1">
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">{{ i18n.status }}</div>
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`">
																		<v-chip dark pill :color="(transaction.done || transaction.approved) ? 'success' : 'red'" small :class="`${arabic ? 'arFont' : 'enFont'}`">
																			{{ transaction.done ? i18n.transaction_done : (transaction.approved ? i18n.transaction_done : i18n.pending) }}
																		</v-chip>
																	</div>
															</v-col>
															<v-col cols="6" class="py-1">
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">{{ i18n.transaction_deadline }}</div>
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ getFormat(transaction.deadline) }}</div>
															</v-col>
															<v-col cols="6" class="py-1">
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">{{ i18n.transaction_amount }}</div>
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ transaction.ammount }} {{ transaction.currency }}</div>
															</v-col>
															<v-col cols="6" class="py-1">
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">{{ i18n.last_update }}</div>
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ getFormat(transaction.updated_at) }}</div>
															</v-col>
															<v-col cols="12" v-if="transaction.note" class="py-1">
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">{{ i18n["note"] }} </div>
																	<div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ transaction.note }}</div>
															</v-col>
													</v-row>
											</v-timeline-item>
									</v-timeline>
							</v-col>
					</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>
  
<script>
import { format } from 'timeago.js';
import Paging from '@/components/Paging'
export default {
	components: {
			Paging
	},
	data() {
		return {
			loading: false,
			resourceSettings: {
				resourceName: null,
				search: false,
				create: false,
				pagination: true,
			},
			resource: []
		}
	},
	computed: {
		user() {
			return this.$store.state.user
		},
		language() {
			return this.$store.state.language
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
	},
	methods: {
		async pageByNumber(n) {
			return new Promise(async (res, rej) => {
					this.loading = true
					if (!this.search) {
							this.resource = await this.$store.dispatch('getResource', { resource: '/transactions', page: `?page=${n}` })
					} else {
							this.resource = await this.$store.dispatch('searchResource', { resource: '/transactions' + `/search?page=${n}`, value: this.search })
					}
					this.loading = false
		})
	},
		getFormat(d){
			return format(d)
		},
				async loadResource() {
						return new Promise(async (res, rej) => {
				this.resource = await this.$store.dispatch('getResource', { resource: '/transactions' })
								res()
						})
				},
				async init() {
						this.loading = true
						await this.loadResource()
						this.loading = false
				},
		},
		async created() {
				await this.init()
		},
}
</script>